/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import * as Types from '../../types'
import { createGenericSlice, GenericState } from '../lib'
import { ResultEntity } from '../../types'
import { downloadFile } from '../../utils/helpers'
import { getResultFileData } from '../../services/endpoints'

const sliceName = 'results'

//todo need to reverse this and use the sate as the type
export interface ResultState extends GenericState<ResultEntity> {}

export const getAllResults = createAsyncThunk(
  `${sliceName}/getAllResults`,
  async (
    query: { [k: string]: string | number } | undefined,
    { rejectWithValue }
  ) => {
    try {
      return await Services.getAllResults(query)
    } catch (err: any) {
      return rejectWithValue({
        code: 'error',
        message: err.message,
        fields: []
      })
    }
  }
)

export const getResult = createAsyncThunk(
  `${sliceName}/getResult`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getResult(id)
    } catch (err: any) {
      return rejectWithValue({
        code: 'error',
        message: err.message,
        fields: []
      })
    }
  }
)

export const downloadResultFile = createAsyncThunk(
  `${sliceName}/downloadResultFile`,
  async (
    data: { data: string | Blob; fileName: string; contentType?: string },
    { rejectWithValue }
  ) => {
    try {
      return await downloadFile(
        data.data,
        data.fileName,
        (data.contentType = 'text/plain')
      )
    } catch (err: any) {
      return rejectWithValue({
        code: 'error',
        message: err.message,
        fields: []
      })
    }
  }
)

export const getResultFile = createAsyncThunk(
  `${sliceName}/getResultFileData`,
  async (
    data: {
      resultFileId: string
      query: {
        [k: string]: string
      }
    },
    { rejectWithValue }
  ) => {
    try {
      return await getResultFileData(data.resultFileId, data.query)
    } catch (err: any) {
      return rejectWithValue({
        code: 'error',
        message: err.message,
        fields: []
      })
    }
  }
)

export const removeResult = createAsyncThunk(
  `${sliceName}/removeResult`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.removeResult(id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      return rejectWithValue({
        code: 'error',
        message: err.message,
        fields: []
      })
    }
  }
)

export const resultsAdapter = createEntityAdapter<Types.ResultEntity>()

// TODO remove any type
const thunkAdapters: any = [
  {
    adapterFn: resultsAdapter.setAll,
    thunk: getAllResults
  },
  {
    adapterFn: (state, action) => {
      resultsAdapter.setAll(state, [action])
    },
    thunk: getResult
  },
  {
    adapterFnmst: resultsAdapter.removeOne,
    thunk: removeResult
  }
]

export const initialResultsState: ResultState = {
  loading: false,
  error: null,
  ids: [],
  entities: {}
}

export const resultsSlice = createGenericSlice({
  name: sliceName,
  initialState: initialResultsState,
  thunkAdapters
})
